module.exports = __webpack_public_path__ + "img/sasha.f4f27137.jpg";